import script from './component-lib.esm90.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('SvgIcon', _vm._g(_vm._b({
    attrs: {
      "viewBox": "0 0 32 32"
    }
  }, 'SvgIcon', Object.assign({}, _vm.$props, {
    title: _vm.$props.title || 'squarespace'
  }, _vm.$attrs), false), _vm.$listeners), [_c('path', {
    attrs: {
      "d": "M30.207 11.625c-2.403-2.401-6.301-2.401-8.752 0l-9.801 9.8c-0.6 0.6-0.6 1.6 0 2.2 0.6 0.599 1.6 0.599 2.2 0l9.801-9.801c1.199-1.199 3.149-1.199 4.352 0 1.2 1.2 1.2 3.152 0 4.352l-9.652 9.652c1.2 1.199 3.149 1.199 4.351 0l7.452-7.452c2.448-2.451 2.448-6.351 0.049-8.751zM26.907 14.875c-0.601-0.6-1.601-0.6-2.2 0l-9.805 9.852c-1.2 1.199-3.148 1.199-4.349 0-0.6-0.6-1.6-0.6-2.2 0s-0.6 1.6 0 2.199c2.401 2.401 6.301 2.401 8.752 0l9.801-9.8c0.599-0.649 0.599-1.652 0.001-2.251zM23.655 5.075c-2.401-2.401-6.301-2.401-8.752 0l-9.801 9.801c-0.6 0.599-0.6 1.599 0 2.199s1.6 0.6 2.2 0l9.86-9.801c1.2-1.199 3.161-1.199 4.36 0 0.601 0.6 1.601 0.6 2.2 0 0.561-0.649 0.561-1.599-0.039-2.199zM20.355 8.324c-0.6-0.6-1.6-0.6-2.2 0l-9.801 9.852c-1.199 1.2-3.151 1.2-4.353 0-1.2-1.199-1.2-3.151 0-4.352l9.652-9.652c-1.2-1.2-3.149-1.2-4.351 0l-7.501 7.453c-2.4 2.4-2.4 6.3 0 8.751 2.401 2.401 6.3 2.401 8.752 0l9.8-9.801c0.601-0.651 0.601-1.651 0-2.251z"
    }
  })]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = undefined;
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;
export { __vue_component__$1 as default };